// Packages
import PropTypes from 'prop-types';

// Components
import Container from 'components/BTDUI/Container';
import Header from 'components/Header';
import Footer from 'components/Footer';

const CustomerEquipmentViewLayout = ({ children }) => {

	return (
		<div className='CustomerEquipmentViewLayout'>
			
			<Header/>

			<Container>

				{children}

			</Container>

			<Footer/>
        </div>
	)
}

CustomerEquipmentViewLayout.propTypes = {
	children: PropTypes.node,
}

CustomerEquipmentViewLayout.defaultProps = {
	children: null,
}

export default CustomerEquipmentViewLayout